import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Row, Col } from 'reactstrap';

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput"

class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            nombre: '',
            host: '',
            username: '',
            password: '',
            port:''
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetForm() {
        this.setState({
            nombre: '',
            host: '',
            username: '',
            password: '',
            port:''
        });
    }

    setSelects(data) {
        this.setState(() => ({
            nombre: data.nombre,
            host: data.host,
            username: data.username,
            password: data.password,
            port: data.port
        }));
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.email.casillas.delete}
                postUrl={api.email.casillas.delete}
                onSubmit={(e) => this.props.onSubmit(e)}
                id={this.props.id}
                successMessage={"La Casilla de Mail ha sido eliminada con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Casilla de Mail"}
                buttonTitle={"Eliminar"}
                buttonIcon={"fa fa-trash fa-lg"}
                saveButton={true}
                buttonClass={"btn-danger"} 
                closeButton={true}
                danger={true}
                saveButtonLabel={"Eliminar"}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetForm()}
            >

                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Nombre"}
                            fieldName={"nombre"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.nombre}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Host"}
                            fieldName={"host"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.host}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Usuario"}
                            fieldName={"username"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.username}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Contraseña"}
                            fieldName={"password"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.password}
                            disabled={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <ParadigmaLabeledInput
                            label={"Puerto"}
                            fieldName={"port"}
                            labelColumns={2}
                            fieldColumns={10}
                            value={this.state.port}
                            disabled={true}
                        />
                    </Col>
                </Row>

            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Config/Casillas/Delete.js